<template>
  <form v-bind="$attrs" @submit.prevent="handleSubmit" ref="formWrapper">
    <slot />
  </form>
</template>

<script>
export default {
  name: 'FormWrapper',
  methods: {
    handleSubmit(event) {
      // Collect form data from FormData or emit a generic submit event
      const formData = new FormData(event.target)
      const data = Object.fromEntries(formData.entries())
      this.submit(data)
    },
    submit(data) {
      /**
       * This is only triggered if everything passes validation.
       * @event submit
       */
      this.$emit('submit', data)
    }
  },
  emits: ['submit']
}
</script>

<style></style>
